module.exports = __webpack_public_path__ + "img/img4.3f15bab4.png";